import { Images } from '@/assets/imgs';
import Image from 'next/image';
import { Tween } from 'react-gsap';
import { Scene } from 'react-scrollmagic';

export const NextGenGamingTokens = () => {
  return (
    <div className="blur-spheres">
      <Scene duration="400%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: -200,
          }}
          to={{
            y: 200,
          }}
        >
          <div className="parallax-token">
            <Image
              src={Images.landing.token_blur}
              alt=""
              width={33}
              height={47}
            />
          </div>
        </Tween>
      </Scene>

      <Scene duration="200%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: -80,
          }}
          to={{
            y: 80,
          }}
        >
          <div className="parallax-token2">
            <Image
              src={Images.landing.token_blur1}
              alt=""
              width={13}
              height={13}
            />
          </div>
        </Tween>
      </Scene>

      <Scene duration="200%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: -100,
          }}
          to={{
            y: 120,
          }}
        >
          <div className="parallax-token3">
            <Image
              src={Images.landing.token_blur2}
              alt=""
              width={13}
              height={13}
            />
          </div>
        </Tween>
      </Scene>

      <Scene duration="200%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: -100,
          }}
          to={{
            y: 120,
          }}
        >
          <div className="parallax-token4">
            <Image
              src={Images.landing.token_blur3}
              alt=""
              width={13}
              height={13}
            />
          </div>
        </Tween>
      </Scene>

      {/* <Scene duration="200%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: -160,
          }}
          to={{
            y: 160,
          }}
        >
          <div className="parallax-token5">
            <Image
              src={Images.landing.token_blur4}
              alt=""
              width={28}
              height={28}
            />
          </div>
        </Tween>
      </Scene> */}

      <Scene duration="200%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: -200,
          }}
          to={{
            y: 240,
          }}
        >
          <div className="parallax-token6">
            <Image
              src={Images.landing.token_blur2}
              alt=""
              width={13}
              height={13}
            />
          </div>
        </Tween>
      </Scene>

      <Scene duration="200%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: -300,
          }}
          to={{
            y: 340,
          }}
        >
          <div className="parallax-token7">
            <Image
              src={Images.landing.token_blur5}
              alt=""
              width={47}
              height={47}
            />
          </div>
        </Tween>
      </Scene>

      <Scene duration="200%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: -100,
          }}
          to={{
            y: 30,
          }}
        >
          <div className="parallax-token8">
            <Image
              src={Images.landing.token_blur6}
              alt=""
              width={13}
              height={13}
            />
          </div>
        </Tween>
      </Scene>

      <Scene duration="200%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: -410,
          }}
          to={{
            y: 110,
          }}
        >
          <div className="parallax-token9">
            <Image
              src={Images.landing.token_blur3}
              alt=""
              width={13}
              height={13}
            />
          </div>
        </Tween>
      </Scene>

      <Scene duration="200%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: -510,
          }}
          to={{
            y: 40,
          }}
        >
          <div className="parallax-token10">
            <Image
              src={Images.landing.token_blur7}
              alt=""
              width={21}
              height={21}
            />
          </div>
        </Tween>
      </Scene>

      <Scene duration="200%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: -310,
          }}
          to={{
            y: 40,
          }}
        >
          <div className="parallax-token11">
            <Image
              src={Images.landing.token_blur7}
              alt=""
              width={59}
              height={59}
            />
          </div>
        </Tween>
      </Scene>

      <Scene duration="200%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: -310,
          }}
          to={{
            y: 110,
          }}
        >
          <div className="parallax-token12">
            <Image
              src={Images.landing.token_blur6}
              alt=""
              width={28}
              height={28}
            />
          </div>
        </Tween>
      </Scene>

      <Scene duration="200%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: -400,
          }}
          to={{
            y: 200,
          }}
        >
          <div className="parallax-token13">
            <Image
              src={Images.landing.token_blur7}
              alt=""
              width={13}
              height={13}
            />
          </div>
        </Tween>
      </Scene>

      <Scene duration="200%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: -400,
          }}
          to={{
            y: 200,
          }}
        >
          <div className="parallax-token14">
            <Image
              src={Images.landing.token_blur3}
              alt=""
              width={39}
              height={39}
            />
          </div>
        </Tween>
      </Scene>

      <Scene duration="200%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: -400,
          }}
          to={{
            y: 400,
          }}
        >
          <div className="parallax-token15">
            <Image
              src={Images.landing.token_blur8}
              alt=""
              width={28}
              height={28}
            />
          </div>
        </Tween>
      </Scene>

      <Scene duration="200%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: -400,
          }}
          to={{
            y: 200,
          }}
        >
          <div className="parallax-token16">
            <Image
              src={Images.landing.token_blur3}
              alt=""
              width={28}
              height={28}
            />
          </div>
        </Tween>
      </Scene>

      <Scene duration="200%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: -400,
          }}
          to={{
            y: 200,
          }}
        >
          <div className="parallax-token17">
            <Image
              src={Images.landing.token_blur9}
              alt=""
              width={13}
              height={13}
            />
          </div>
        </Tween>
      </Scene>

      <Scene duration="200%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: -100,
          }}
          to={{
            y: 200,
          }}
        >
          <div className="parallax-token18">
            <Image
              src={Images.landing.token_blur}
              alt=""
              width={13}
              height={13}
            />
          </div>
        </Tween>
      </Scene>

      <Scene duration="200%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: -100,
          }}
          to={{
            y: 100,
          }}
        >
          <div className="parallax-token19">
            <Image
              src={Images.landing.token_blur10}
              alt=""
              width={28}
              height={28}
            />
          </div>
        </Tween>
      </Scene>

      <Scene duration="200%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: -100,
          }}
          to={{
            y: 100,
          }}
        >
          <div className="parallax-token20">
            <Image
              src={Images.landing.token_blur11}
              alt=""
              width={28}
              height={28}
            />
          </div>
        </Tween>
      </Scene>

      <Scene duration="200%" triggerHook="onEnter">
        <Tween
          position="0"
          from={{
            y: -100,
          }}
          to={{
            y: 100,
          }}
        >
          <div className="parallax-token21">
            <Image
              src={Images.landing.token_blur10}
              alt=""
              width={14}
              height={14}
            />
          </div>
        </Tween>
      </Scene>
    </div>
  );
};
